<template>
  <div class="game">
    <AppBtn
      @click.native="openFrame = true"
      class="game-fullscreen _my-8 _ml-auto _mr-16 _py-2 _px-3"
      :btnClass="'btn_primary'"
    >
      <div class="d-flex align-center">
        <span class="_mr-4">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.5 9.50012L3 3.00012M15.5 9.50012L22 3.00012"
              stroke="#fff"
              stroke-width="1.5"
              stroke-miterlimit="16"
            />
            <path
              d="M15.5 14.5001L22 21.0001M9.5 14.5001L3 21.0001"
              stroke="#fff"
              stroke-width="1.5"
              stroke-miterlimit="16"
            />
            <path d="M8 3.00012H3V8.00012" stroke="#fff" stroke-width="1.5" />
            <path d="M8 21.0001H3V16.0001" stroke="#fff" stroke-width="1.5" />
            <path
              d="M22 8.00012L22 3.00012L17 3.00012"
              stroke="#fff"
              stroke-width="1.5"
            />
            <path
              d="M22 16.0001L22 21.0001L17 21.0001"
              stroke="#fff"
              stroke-width="1.5"
            />
          </svg>
        </span>
        На весь экран
      </div>
    </AppBtn>
    <div class="game-iframe" :class="{ 'game-iframe_opened': openFrame }">
      <AppBtn
        @click.native="openFrame = false"
        v-if="openFrame"
        class="game-fullscreen__close-btn _ml-auto _mr-2 _my-8 _py-2 _px-3"
        :btnClass="'btn_primary'"
      >
        <div class="d-flex align-center">
          <span>Выйти из полноэкранного режима</span>
        </div>
      </AppBtn>
      <iframe
        :src="`/content/game/${currentLocale}/story.html`"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { Trans } from '@/plugins/translation'
import AppBtn from '@/components/UI/buttons/AppBtn'
export default {
  name: 'GameRSM',
  components: {
    AppBtn,
  },
  data: () => ({
    openFrame: false,
  }),
  computed: {
    currentLocale() {
      return Trans.currentLocale.trim()
    },
  },
}
</script>

<style lang="scss">
.game {
  &-iframe {
    position: relative;
    width: 100%;

    & iframe {
      width: 100%;
      height: 800px;

      @media screen and (max-width: 1220px) {
        width: 100%;
        height: 100%;
      }
    }

    @media screen and (max-width: 1220px) {
      display: none;
    }
  }

  &-iframe_opened {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    padding: 34px;

    & iframe {
      height: 100%;
    }
  }

  &__close-btn {
    cursor: pointer;
    position: absolute;
    top: 24px;
    right: 24px;
    z-index: 2;

    @media screen and (max-width: 1220px) {
      top: 0;
      right: 50%;
      transform: translateX(50%);
    }
  }
}
</style>
